module.exports = __webpack_public_path__ + "img/personal_resources_no_list.65012f44.png";